import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';

export const commonService = {
	getapiVersion,
	getUIAndApiVersion
};

// #region admin

function getapiVersion () {
	return axios.get(utilityService.buildFullyQualifiedUrl(`admin/build`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion admin


function getUIAndApiVersion () {
	return axios.get(utilityService.buildFullyQualifiedUrl(`ops/build`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}
